module.exports = __webpack_public_path__ + "img/alexia.0b34cfe7.jpg";